module.exports = __webpack_public_path__ + "static/media/my-books.6ba45136.svg";